import { useState, useEffect } from 'react';
import './ConfirmationStep.scss';
import { HealthPatientCoverage, Medicine, PatientRecordDTO } from '../../../../interface/interface';
import { Button } from 'primereact/button';
import { InputDate } from 'medere-ui-framework';

export default function ConfirmationStep({ professionalName, patient, selectedCoverage, medications, prolongedTreatment, hidePatientData, handleNext, handleBack, recipeDate, setRecipeDate }:{professionalName: string, patient: PatientRecordDTO|null, selectedCoverage: HealthPatientCoverage|undefined, medications:Medicine[]|null, prolongedTreatment: boolean, hidePatientData: boolean, handleNext: () => void, handleBack: () => void, recipeDate: Date, setRecipeDate: (rp: Date) => void}) {
    const medicineQuantity = medications.reduce((total, medicine) => total + medicine.quantity, 0) ?? 0

    const [isMobile, setisMobile] = useState(window.innerWidth < 700)
    const [lessThan480, setLessThan480] = useState(window.innerWidth < 480)
    const [greaterThan825, setGreaterThan825] = useState(window.innerWidth >= 825)
    useEffect(() => {

        if (!recipeDate) 
            setRecipeDate(generateDate())

        const handleResize = () => {
            setisMobile(window.innerWidth < 700)
            setLessThan480(window.innerWidth < 480)
            setGreaterThan825(window.innerWidth >= 825)
        };
        window.addEventListener('resize', handleResize)
        return () => {
          window.removeEventListener('resize', handleResize)
        }
    }, [])

    function generateDate() {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate());

        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1;
        const day = currentDate.getDate();

        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;

        const formattedDate = `${year}-${formattedMonth}-${formattedDay}T03:00:00.000Z`;

        return new Date(formattedDate);
    }

    if (isMobile)
        return (
            <div className="confirmation-step">
                {medicineQuantity > 3 && <div style={{marginTop:'10px', marginBottom:'20px', padding:'12px', backgroundColor: 'rgba(255, 193, 7, 0.2)', borderRadius:'8px', display:'flex', flexDirection:'row'}}>
                    <i className="pi pi-exclamation-triangle" style={{ marginRight: '5px', color:'#FFC107', fontSize: greaterThan825?'20px':'30px', paddingTop: lessThan480? '18px':(greaterThan825?'1px':'5px') }}></i>
                    <label>Existen <strong>{medicineQuantity +" medicamentos"}</strong> en tu receta, por lo que se generará 1 receta cada 3 items ingresados.</label>
                </div>}
                <div className='border-grey whitepadmb'>
                    <div style={{fontWeight:500}}>{professionalName}</div>
                </div>
                <div style={{ paddingBottom: '30px' }}>
                    <label><strong>Fecha de receta</strong></label>
                    <InputDate className='border-grey' value={recipeDate} onChange={(e: any) => setRecipeDate(e.target.value)}/>
                </div>
                <div style={{fontWeight:500}} className='border-grey whitepadmb'>
                    <div><strong>{patient?.firstname+" "+patient?.lastname}</strong></div>
                    <div>{selectedCoverage ? "Afiliado: "+selectedCoverage.benefitnumber : "Sin obra social"}</div>
                    <div>{selectedCoverage ? selectedCoverage.healthentityplan.healthentity.commercialname : null}</div>
                    <div>Cel.: {patient?.mobilephone}</div>
                </div>
                <div className='border-grey whitepadmb'>
                    <h3><strong>{"Medicamentos"}</strong></h3>
                    <ul style={{ listStyleType: 'disc', paddingLeft: '20px', fontWeight:500 }}>
                        {medications?.map((med:Medicine, index) => (
                            <li key={index} style={{ marginBottom: '10px' }}>
                                <div>{(med.issubstance? med.drugdescription : med.medicinalproductdescription) + " " + med.presentationdescription}</div>
                                <div>Indicación: {med.indications?med.indications:"-"}</div>
                                <div>Diagnóstico: {med.diagnosis?med.diagnosis:"-"}</div>
                                <div>Cantidad: {med.quantity}</div>
                                {med.duplicate && <div><strong style={{fontFamily:'sans-serif', fontStyle:'italic'}}>Por duplicado</strong></div>}
                            </li>
                        ))}
                    </ul>
                </div>
                {prolongedTreatment && <div className='border-grey whitepadmb'>
                    <h3><strong>{"Tratamiento prolongado"}</strong></h3>
                </div>}
                {hidePatientData && <div className='border-grey whitepadmb'>
                    <h3><strong>{"Ocultar datos del paciente"}</strong></h3>
                </div>}
            </div>
        );
    else 
        return (
            <div>
                {medicineQuantity > 3 && (
                    <div style={{ marginTop: '10px', marginBottom: '20px', marginRight: '1rem', padding: '12px', backgroundColor: 'rgba(255, 193, 7, 0.2)', borderRadius: '8px', display: 'flex', flexDirection: 'row' }}>
                        <i className="pi pi-exclamation-triangle" style={{ marginRight: '5px', color: '#FFC107', fontSize: '20px' }}></i>
                        <label>Existen <strong>{medicineQuantity + " medicamentos"}</strong> en tu receta, por lo que se generará 1 receta cada 3 items ingresados.</label>
                    </div>
                )}
            
                <div className="confirmation-step" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    <div style={{ flex: '1', marginRight: '2rem' }}>
                        <div className='border-grey whitepadmb'>
                            <div style={{ fontWeight: 500 }}>{professionalName}</div>
                        </div>
                        <div style={{ paddingBottom: '30px' }}>
                            <label><strong>Fecha de receta</strong></label>
                            <InputDate className='border-grey' value={recipeDate} onChange={(e: any) => setRecipeDate(e.target.value)}/>
                        </div>
                        <div style={{ fontWeight: 500 }} className='border-grey whitepadmb'>
                            <div><strong>{patient?.firstname + " " + patient?.lastname}</strong></div>
                            <div>{selectedCoverage ? "Afiliado: " + selectedCoverage.benefitnumber : "Sin obra social"}</div>
                            <div>{selectedCoverage ? selectedCoverage.healthentityplan.healthentity.commercialname : null}</div>
                            <div>Cel.: {patient?.mobilephone}</div>
                        </div>
                        {prolongedTreatment && (
                            <div className='border-grey whitepadmb'>
                                <h3><strong>Tratamiento prolongado</strong></h3>
                            </div>
                        )}
                        {hidePatientData && (
                            <div className='border-grey whitepadmb'>
                                <h3><strong>Ocultar datos del paciente</strong></h3>
                            </div>
                        )}
                    </div>
                    
                    <div style={{ flex: '1', borderLeft: '4px solid rgba(28, 50, 79, 0.38)', paddingLeft: '1rem', paddingRight: '1rem', marginBottom: '1rem', height: 'fit-content' }}>
                        <div className='border-grey whitepadmb'>
                            <h3><strong>Medicamentos</strong></h3>
                            <div style={{height: 'fit-content', maxHeight: '370px', overflow: 'auto', padding: '10px', borderRadius: '4px'}}>
                                <ul style={{ listStyleType: 'disc', paddingLeft: '20px', fontWeight: 500 }}>
                                    {medications?.map((med: Medicine, index) => (
                                        <li key={index} style={{ marginBottom: '10px' }}>
                                            <div>{(med.issubstance ? med.drugdescription : med.medicinalproductdescription) + " " + med.presentationdescription}</div>
                                            <div>Indicación: {med.indications?med.indications:"-"}</div>
                                            <div>Diagnóstico: {med.diagnosis}</div>
                                            <div>Cantidad: {med.quantity}</div>
                                            {med.duplicate && <div><strong style={{ fontFamily: 'sans-serif', fontStyle: 'italic' }}>Por duplicado</strong></div>}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', marginTop: 'auto' }}>
                            <div style={{ display: 'flex', justifyContent: 'start', gap: '1rem' }}>
                                <Button
                                    className='btnRpContinue'
                                    label={"Finalizar receta"}
                                    onClick={handleNext} 
                                    style={{ width: '170px', backgroundColor: '#14C7BC', border: 'none', height: '36px' }}
                                />
                                <Button
                                    className='btnRpBack'
                                    label={"Hacer cambios"}
                                    onClick={handleBack}
                                    style={{ width: '170px', backgroundColor: '#FFFFFF', color: '#545454', height: '36px', border: '1px solid #3CB8BA' }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
}
